<div class="d-flex justify-content-between align-items-center">
    <h2 mat-dialog-title><span [textContent]="(helpDoc?.fileName || '') + ' Preview'"></span></h2>
    <span class="material-icons mb-1" mat-dialog-close>close</span>
</div>
<mat-dialog-content class="mat-typography" *transloco="let translate">
    <iframe [src]="helpDoc?.fileUrl" [title]="translate('Help Document')" width="100%" height="100%" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <material-button [buttonType]="'icon'" [size]="'small'" [titleText]="'Close'" [prefixIcon]="'close'" mat-dialog-close [classList]="['focus:outline-none']"></material-button>
</mat-dialog-actions>
